module.exports = __webpack_public_path__ + "img/user-data-desc.01e3c76e.svg";